import { customInstance } from "@/lib/axios";

export type MarketingCategory = "ARTICLES" | "TRADESHOWS" | "UPDATES";

export type PublicMarketingAsset = {
  id: number;
  url: string;
  alt_text: string;
  caption: string;
};

export type PublicMarketingBlock = {
  id: number;
  sort_order: number;
  block_type: "hero" | "rich_text" | "image" | "cta" | "two_column";
  data: Record<string, any>;
  asset: PublicMarketingAsset | null;
};

export type PublicMarketingPageListItem = {
  id: number;
  slug: string;
  category: MarketingCategory;
  title: string;
  excerpt: string;
  cover_image_url: string | null;
  published_at: string | null;
  event_start_date: string | null;
  event_end_date: string | null;
  meta_description: string;
  meta_og_title: string;
  meta_og_description: string;
  meta_og_image_url: string | null;
  canonical_path: string;
  blocks: null;
};

export type PublicMarketingPageDetail = Omit<PublicMarketingPageListItem, "blocks"> & {
  blocks: PublicMarketingBlock[];
};

export type PaginatedResponse<T> = {
  count: number;
  page: number;
  page_size: number;
  has_next: boolean;
  has_previous: boolean;
  results: T[];
};

export async function fetchMarketingPages(params: { category: MarketingCategory; page?: number }) {
  const resp = await customInstance.get<PaginatedResponse<PublicMarketingPageListItem>>(
    "/api/public/marketing/pages/",
    { params: { category: params.category, page: params.page ?? 1 } }
  );
  return resp.data;
}

export async function fetchMarketingPageDetail(params: { categoryPath: string; slug: string }) {
  const resp = await customInstance.get<PublicMarketingPageDetail>(
    `/api/public/marketing/pages/${encodeURIComponent(params.categoryPath)}/${encodeURIComponent(params.slug)}/`
  );
  return resp.data;
}

